module.exports = __webpack_public_path__ + "2bdbb592e0df86fc90c80d309f8a6d3f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/AdaptiveDirectionalityOFF.mp4
// module id = 388
// module chunks = 0